module.exports = __webpack_public_path__ + "static/media/rio-quente-go.3aa5cb15.jpg";